export default "__VITE_ASSET__d0af3bc1__"